import { LOGOUT } from "../../../constants/ClientConstants";

export default function logoutAction() {
    return {
        type: LOGOUT
    };
}
